module.exports = "<div class=\"gw-loader\" ng-class=\"{'gw-loader_page-loader': pageLoader}\">\r\n    <div class=\"gw-loader__opacity\"></div>\r\n\r\n    <div class=\"gw-loader__progress-wrap\">\r\n        <gw-progress/>\r\n\r\n        <div class=\"gw-loader__text\" ng-if=\"text\">\r\n            {{text}}\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/loading/templates/loader.html
// module id = 585
// module chunks = 0